import { usePrefs } from "@/contexts/PrefsContext";
import { Sun, Moon, Monitor } from "lucide-react";
import { useState, useRef, useEffect } from "react";

/**
 * Theme switcher — light | dark | system. Persists via PrefsContext.
 */
export default function ThemeToggle() {
    const { prefs, updatePrefs } = usePrefs();
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    useEffect(() => {
        function onDoc(e) { if (ref.current && !ref.current.contains(e.target)) setOpen(false); }
        if (open) document.addEventListener("mousedown", onDoc);
        return () => document.removeEventListener("mousedown", onDoc);
    }, [open]);

    const Icon = prefs.theme === "dark" ? Moon : prefs.theme === "system" ? Monitor : Sun;
    return (
        <div className="relative" ref={ref}>
            <button
                onClick={() => setOpen((v) => !v)}
                className="w-9 h-9 inline-flex items-center justify-center border border-stone-200 dark:border-stone-700 rounded-full text-stone-600 dark:text-stone-300 hover:border-stone-300"
                data-testid="theme-toggle-btn"
                aria-label="Theme"
            >
                <Icon size={15} />
            </button>
            {open && (
                <div className="absolute right-0 mt-2 w-40 bg-white dark:bg-stone-900 border border-stone-200 dark:border-stone-800 rounded-xl shadow-xl z-50 overflow-hidden" data-testid="theme-menu">
                    {[
                        { k: "light", label: "Light", I: Sun },
                        { k: "dark", label: "Dark", I: Moon },
                        { k: "system", label: "System", I: Monitor },
                    ].map(({ k, label, I }) => (
                        <button
                            key={k}
                            onClick={() => { updatePrefs({ theme: k }); setOpen(false); }}
                            className={`w-full flex items-center gap-2 px-4 py-2 text-sm hover:bg-stone-50 dark:hover:bg-stone-800 ${
                                prefs.theme === k ? "text-stone-900 dark:text-white font-semibold" : "text-stone-600 dark:text-stone-300"
                            }`}
                            data-testid={`theme-opt-${k}`}
                        >
                            <I size={14} /> {label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
